import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

import { ReactComponent } from './close.svg';

export const CloseIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon ref={ref} component={ReactComponent} inheritViewBox {...props} />
  ),
);

if (process.env.NODE_ENV !== 'production') {
  CloseIcon.displayName = 'CloseIcon';
}
